// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"86fe5a49","453":"127be8e2","455":"b410adf8","977":"670b9fab"}[chunkId] + ".chunk.js";
};